angular.module('ihestiaCommonDirectives').config(['$popoverProvider', function($popoverProvider) {
  angular.extend($popoverProvider.defaults, {
    template: 'ihestia-commondirectives-template-app/directives/popover/popover.tpl.html'
  });
}]);

